const getLoadError = (initialLoading = false) => ({
  loading: initialLoading === true,
  error: { message: "", details: "" },
});

const getRowDynamicRate = () => ({
  rowId: -1,
  id: "",
  isActivate: false,
  name: "",
  ubicationName: "",
  ubicationCoordinates: {},
  initialRate: 0,
  isDynamic: true,
  pricePerKilometer: 0,
  kilometers: 0,
  startHour: "",
  endHour: "",
  priceOnDemand: 0,
  isDemand: false,
  startHour2: "",
  endHour2: "",
  priceOnDemand2: 0,
  isDemand2: false,
  color: "orange",
  priority: "principal",
  polygons: [],
  createdBy: "",
});

const tableRowsTemplate = [
  {
    id: "",
    name: "",
    initialRate: 0,
    isDynamic: false,
    pricePerKilometer: 0,
    kilometers: 0,
    startHour: "",
    endHour: "",
    priceOnDemand: 0,
    isDemand: false,
    color: "orange",
    priority: "ninguno",
    polygons: [],
  },
];

export default {
  tableRowsTemplate,
  getLoadError,
  getRowDynamicRate,
};
